import React from "react";
import { Container } from "react-bootstrap";
const GridContainer = (props) => {
    return (React.createElement(Container, { className: props.parentClass, fluid: props.fluid }, props.children));
};
export default GridContainer;
